<template>
	<div class="full">
		<vxe-table :data="tableData" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="name" title="姓名"></vxe-column>
			<vxe-column show-overflow field="departmentid" title="部门" :formatter="getdepartment"></vxe-column>
			<vxe-column field="postjob" title="岗位" :formatter="getpostjob"></vxe-column>
			<vxe-column field="joblevel" title="职务级别" :formatter="getjoblevel"></vxe-column>
			<vxe-column field="staffstatus" title="状态" :formatter="getEmun"></vxe-column>
<!-- 			<vxe-column field="goodsname" title="sku名称"></vxe-column>
			<vxe-column field="goodscode" title="sku编码">
				<template #default="{ row }">
					<el-link type="primary" style="font-size: 12px;" @click="getgoodsidbygroupcode(row)">
						{{row.goodscode}}</el-link>
				</template>
			</vxe-column>
			<vxe-column field="goodsprice" title="价格"></vxe-column>
			<vxe-column show-overflow field="link" title="商品链接">
				<template #default="{ row }">
					<el-link type="primary" style="font-size: 12px;" :href="row.link" target="_blank">跳转</el-link>
				</template>
			</vxe-column> -->

		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'groupstaffIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				allAlign: null,
				tableData: []
			}
		},
		watch: {
			// row(e){
			// 	if(e){
			// 		this.getonline()
			// 	}		
			// }
		},
		created() {

		},
		mounted() {
			
		},
		computed: {

		},

		methods: {
			getstaff() {
				this.$api.joblevel.getstaff(this.row.id).then((res) => {
					this.tableData = res
				})
			},
			getdepartment({cellValue}){
				return window.systemMethods.getdepartment(cellValue)
			},
			getpostjob({cellValue}){
				return window.systemMethods.getpostjob(cellValue)
			},
			getjoblevel({cellValue}){
				return window.systemMethods.getjoblevel(cellValue)
			},
			getEmun({column,cellValue}){
				console.log(column.field, cellValue)
				return window.systemMethods.getEmunValue(column.field, cellValue)
			}
		},
		components: {

		}
	}
</script>
